import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { ReactNode } from "react"

interface DeleteAdminModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  adminName: string
  onConfirm: () => void
  title?: string
  description?: ReactNode
  confirmLabel?: string
}

export function DeleteAdminModal({
  open,
  onOpenChange,
  adminName,
  onConfirm,
  title = "Delete Admin",
  description,
  confirmLabel = "Delete Admin",
}: DeleteAdminModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {description ?? (
              <>
                Are you sure you want to delete <strong>{adminName}</strong>? This action cannot be
                undone and will permanently remove the admin and all associated data.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
